export const constants = {
  UPDATE_FILTER: 'UPDATE_FILTER',
  RESET_FILTER: 'RESET_FILTER',
  GET_INFLUENCER_REQUEST: 'GET_INFLUENCER_REQUEST',
  GET_INFLUENCER_SUCCESS: 'GET_INFLUENCER_SUCCESS',
  GET_INFLUENCER_FAILURE: 'GET_INFLUENCER_FAILURE',
};
